import { Fragment, useEffect, useMemo } from 'react';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import CanonicalLink from 'marketplace-ui-common/components/elements/CanonicalLink';
import MetaDescription from 'marketplace-ui-common/components/elements/MetaDescription';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import PrerenderReady from 'marketplace-ui-common/components/prerender/PrerenderReady';
import { getPublicDetailPageFullUrl } from '../../../utils/urls';
import { PublicOnly } from '../../../selectors/app';
import AssetDetailsSocialSharing from './AssetDetailsSocialSharing';
import AssetDetailsStructuredData from './AssetDetailsStructuredData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssetDetailsDocumentHead({
  assetDetails,
  offeringType,
  ready
}) {
  const {
    name,
    offering: {
      installsCount
    },
    provider: {
      name: providerName
    },
    pricing: {
      cents
    },
    reviewSummary: {
      overallRating,
      reviewCount
    },
    slug,
    thumbnailUrl,
    versionPublishedAt,
    offeringId
  } = assetDetails;
  const lang = getLang();
  const canonicalUrl = useMemo(() => getPublicDetailPageFullUrl(lang, offeringType, slug), [lang, offeringType, slug]);
  const documentTitle = I18n.text('marketplace-assets-ui.details.documentTitle', {
    name,
    offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}`),
    providerName
  });
  const metaDescription = unescapedText('marketplace-assets-ui.details.metaDescription', {
    installsCount,
    name,
    offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}_lowercase`),
    providerName
  });
  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx(PublicOnly, {
      children: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(CanonicalLink, {
          href: canonicalUrl
        }), /*#__PURE__*/_jsx(MetaDescription, {
          content: metaDescription
        }), /*#__PURE__*/_jsx(PrerenderReady, {
          ready: ready
        }), /*#__PURE__*/_jsx(AssetDetailsSocialSharing, {
          canonicalUrl: canonicalUrl,
          description: metaDescription,
          title: documentTitle
        }), /*#__PURE__*/_jsx(AssetDetailsStructuredData, {
          offeringId: offeringId,
          offeringType: offeringType,
          canonicalUrl: canonicalUrl,
          cents: cents,
          metaDescription: metaDescription,
          name: name,
          overallRating: overallRating,
          providerName: providerName,
          reviewCount: reviewCount,
          thumbnailUrl: thumbnailUrl,
          versionPublishedAt: versionPublishedAt
        })]
      })
    })
  });
}
export default AssetDetailsDocumentHead;